import React, { useState, useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar, FiClock } from "react-icons/fi";
import { FaUser, FaCheck, FaCommentDots, FaCalendar } from "react-icons/fa";

export default function ActivityFeed() {
  const [dropdown, setDropdown] = useState(false);
  const [filter, setFilter] = useState("Today");

  const dropdownRef = useRef();

  // ✅ Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const dataMap = {
    Today: [
      {
        icon: <FaCommentDots />,
        color: "orange",
        title: "Michael Chen replied to TKT-1247",
        desc: "Added troubleshooting steps for connect",
        time: "5 min ago",
      },
      {
        icon: <FaUser />,
        color: "blue",
        title: "New ticket assigned to Sarah Johnson",
        desc: "TKT-1248: Network connectivity issues",
        time: "12 min ago",
      },
      {
        icon: <FaCheck />,
        color: "green",
        title: "TKT-1240 marked as resolved",
        desc: "Password reset completed successfully",
        time: "34 min ago",
      },
      {
        icon: <FaCalendar />,
        color: "red",
        title: "SLA deadline approaching",
        desc: "TKT-1239 has 2 hours remaining",
        time: "45 min ago",
      },
    ],
    Weekly: [
      {
        icon: <FaUser />,
        color: "blue",
        title: "Weekly report generated",
        desc: "All systems stable",
        time: "2 days ago",
      },
    ],
    Monthly: [
      {
        icon: <FaCheck />,
        color: "green",
        title: "Monthly maintenance completed",
        desc: "No downtime recorded",
        time: "5 days ago",
      },
    ],
  };

  const list = dataMap[filter];

  return (
    <Card className="activity-card">
      <Card.Body>

        {/* HEADER */}
        <div className="header">
          <h5>Activity Feed</h5>

          <div className="   justify-content-between" ref={dropdownRef}>
            <div
              className="dropdown-btn text-dark text-end rounded rounded-1"
              onClick={() => setDropdown(!dropdown)}
            >
              <FiCalendar /> {filter}
              
            </div>

            {dropdown && (
              <div className="dropdown-menu-custom">
                {["Today", "Weekly", "Monthly"].map((item) => (
                  <div
                    key={item}
                    className={`dropdown-item-custom ${
                      filter === item ? "active" : ""
                    }`}
                    onClick={() => {
                      setFilter(item);
                      setDropdown(false);
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* LIST */}
        <div className="activity-list">
          {list.map((item, i) => (
            <div key={i} className="activity-item">
              <div className={`icon ${item.color}`}>
                {item.icon}
              </div>

              <div className="content">
                <h6>{item.title}</h6>
                <p>{item.desc}</p>

                <div className="time">
                  <FiClock /> {item.time}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="footer">
          View All Activity
        </div>

      </Card.Body>

      {/* ✅ INTERNAL CSS */}
      <style>{`
        .activity-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 12px;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header h5 {
          font-weight: 600;
          margin: 0;
        }

        // .right {
        //   position: relative;
        // }

        /* BUTTON */
        .dropdown-btn {
          border: 1px solid #e5e7eb;
          background: #fff;
           padding: 6px 10px;
           border-radius: 10px;
          display: flex;
          align-items: center;
         gap: 6px;
          font-size: 13px;
          cursor: pointer;
          height: 36px;
        }

        .dropdown-btn:hover {
          border-color: #ff6a00;
        }

        /* DROPDOWN */
        .dropdown-menu-custom {
          position: absolute;
          // top: 115%;
          right: 0;
          width: 170px;
          background: #fff;
          border-radius: 14px;
          padding: 10px 0;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
          z-index: 999;
        }

        .dropdown-item-custom {
          padding: 12px 18px;
          font-size: 15px;
          cursor: pointer;
        }

        .dropdown-item-custom:hover {
          background: #fff3e6;
          color: #ff6a00;
        }

        .dropdown-item-custom.active {
          background: #ff6a00;
          color: #fff;
        }

        /* LIST */
        .activity-list {
          margin-top: 15px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .activity-item {
          display: flex;
          gap: 14px;
        }

        .icon {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .orange { background: #fde8dd; color: #f97316; }
        .blue { background: #e0f2fe; color: #0284c7; }
        .green { background: #dcfce7; color: #16a34a; }
        .red { background: #fee2e2; color: #ef4444; }

        .content h6 {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
        }

        .content p {
          margin: 3px 0;
          font-size: 13px;
          color: #6b7280;
        }

        .time {
          font-size: 12px;
          display: flex;
          align-items: center;
          gap: 4px;
          color: #6b7280;
        }

        .footer {
          margin-top: 15px;
          text-align: center;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          cursor: pointer;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .header h5 {
            font-size: 16px;
          }

          .dropdown-btn {
            height: 32px;
            font-size: 12px;
          }

          .icon {
            width: 38px;
            height: 38px;
          }
        }

        @media (max-width: 1024px) {
          .activity-card {
            margin-top: 20px;
          }
        }
      `}</style>
    </Card>
  );
}